import { render, staticRenderFns } from "./NavMenu.vue?vue&type=template&id=28853c70"
import script from "./NavMenu.vue?vue&type=script&lang=js"
export * from "./NavMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/alidata/server/jenkins/workspace/sunion-test-web-os/03SRC/web-os/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28853c70')) {
      api.createRecord('28853c70', component.options)
    } else {
      api.reload('28853c70', component.options)
    }
    module.hot.accept("./NavMenu.vue?vue&type=template&id=28853c70", function () {
      api.rerender('28853c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/layout/NavMenu.vue"
export default component.exports